import { useAppDispatch } from "src/common/state/hooks";
import { AppDispatch } from "src/common/state/store";
import { closeStandardModal, openStandardModal } from "src/common/state/slice/modal/modalSlice";
import { setMediaSearch } from "src/features/gallery/state/gallerySlice";
import ModalGallery from "src/features/graph/components/ModalGallery";
import { IMedia } from "src/model/unityObject";

// Primes the gallery filters for reference-image picking and opens the shared
// "modal-gallery" modal. media360tag is explicitly cleared: setMediaSearch
// merges (gallerySlice Object.assign), and a tag leaked from an earlier picker
// context would silently block selection. Scenaria accepts both 2D and 360°
// images as reference (same describeAttachedImages path) — no tag filter.
export const openReferenceImageGallery = (dispatch: AppDispatch) => {
  dispatch(setMediaSearch({ mediaType: "image", media360tag: "", query: "", page: 0 }));
  dispatch(openStandardModal("modal-gallery"));
};

interface ReferenceImageGalleryHostProps {
  /** ModalGallery is hard-wired to the "modal-gallery" modal id, so only ONE
   * instance may be mounted at a time or every open renders twice. The host
   * therefore mounts its instance only while its own picking session is
   * active — callers flip this before calling openReferenceImageGallery. */
  open: boolean;
  onPicked: (media: IMedia) => void;
  onClosed: () => void;
}

// The single gallery instance backing every reference-image entry point
// (composer attach button, plan-card decor row, Options provenance row).
// Mounted once at Chatbot root, it serves both the thread and configure
// stages — picking anywhere lands in the same staged state.
const ReferenceImageGalleryHost = ({
  open,
  onPicked,
  onClosed,
}: ReferenceImageGalleryHostProps) => {
  const dispatch = useAppDispatch();
  if (!open) return null;
  return (
    <ModalGallery
      nodeId="profile"
      allowedMediaTypeOverride="image"
      onMediaChange={(media: IMedia) => {
        dispatch(closeStandardModal("modal-gallery"));
        onClosed();
        onPicked(media);
      }}
      onCancel={() => {
        dispatch(closeStandardModal("modal-gallery"));
        onClosed();
      }}
    />
  );
};

export default ReferenceImageGalleryHost;
